import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ProfileView.css';

// Query 
import profileViewDetail from './profileView.graphql';

// Component
import ProfileVerifiedView from '../../../components/siteadmin/ProfileVerifiedView';
import Loader from '../../../components/Loader';
import NotFound from '../../notFound/NotFound';
import { withQuery } from '../../../hoc/withGraphql';

const ProfileView = (props) => {

    const { data: { loading, showUserProfile }, title, profileId } = props;
    if (loading) {
        return <Loader type={"text"} />;
    }

    if (showUserProfile) {
        return <ProfileVerifiedView
            data={showUserProfile}
            title={title}
            profileId={profileId}
        />;
    }

    if (!showUserProfile) {
        return <NotFound />
    }
}

ProfileView.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        showUserProfile: PropTypes.array,
    })
};

ProfileView.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(profileViewDetail,
        {
            options: (props) => ({
                variables: {
                    profileId: props.profileId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(ProfileView);
